<template>
  <div id="student-loan-thresholds">
    <el-row>
      <el-col :span="12">
        <p>Student Loan Thresholds</p>
      </el-col>
      <el-col :span="12">
        <el-button
          size="mini"
          class="right"
          type="danger"
          plain
          style="margin-left: 10px;"
          @click="delete_last_time_frame()"
        >
          Delete latest time frame
        </el-button>
        <el-button
          size="mini"
          class="right"
          type="primary"
          plain
          @click="show_dialog = true"
        >
          New Student Loan Threshold
        </el-button>
      </el-col>
    </el-row>
    <el-collapse v-model="active_names">
      <el-collapse-item
        v-for="(time,index) in student_loan_thresholds"
        :key="time.id"
        :name="index"
        :title="time.start + ' - ' + (time.ends || 'open') + ' - Rate: ' + time.rate + '%' "
      >
        <el-table
          :data="time.student_loan_thresholds"
        >
          <el-table-column
            prop="frequency"
            label="Frequency"
          />
          <el-table-column
            prop="threshold"
            label="Threshold"
          >
            <template #default="scope">
              <money :amount="scope.row.threshold" />
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      title="New Student Loan Threshold"
      :visible.sync="show_dialog"
      width="30%"
      @opened="set_default_input()"
    >
      <el-form
        ref="student_loan_threshold"
        :model="student_loan_threshold"
        label-width="200px"
        :rules="rules"
      >
        <el-form-item
          label="Start student loan period"
          prop="start"
          required
        >
          <el-date-picker
            v-model="student_loan_threshold.start"
            placeholder="Start loan period"
            format="dd.MM.yyyy"
            size="small"
            type="datetime"
          />
        </el-form-item>
        <el-form-item
          label="Rate in percent"
          required
          prop="rate"
        >
          <el-input-number
            v-model="student_loan_threshold.rate"
            size="small"
            :precision="2"
            :step="1"
            :max="100"
          />
        </el-form-item>
        <el-form-item
          label="Frequency"
          required
          prop="frequency"
        >
          <el-select
            v-model="student_loan_threshold.frequency"
            size="small"
          >
            <el-option
              v-for="item in frequencies"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Threshold"
          required
          prop="threshold"
        >
          <el-input-number
            v-model="student_loan_threshold.threshold"
            size="small"
            :precision="2"
            :step="0.5"
            :max="1000000"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="create_student_loan_thresholds"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {timeframe_student_loans, create_student_loan_thresholds, delete_timeframe_student_loans} from '../../api/student_loan_thresholds';
import Money from '../shared/Money';
export default {
  name: 'StudentLoanThreshold',
  components: {Money},
  data() {
    return {
      student_loan_thresholds: [{id: '', start: '', ends: ''}],
      student_loan_threshold: { start: '', frequency: '', threshold: 0, rate: 12 },
      show_dialog: false,
      timeframe: [],
      rules: {
        start: [{ required: true, message: ' ' }],
        threshold: [{ required: true, message: ' ', trigger: 'blur' }],
        frequency: [{ required: true, message: ' ', trigger: 'blur' }],
        rate: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      active_names: [0],
      frequencies: [{
        value: 'weekly',
        label: 'weekly'
      }, {
        value: 'fortnightly',
        label: 'fortnightly'
      }, {
        value:  'three-weekly',
        label:  'three-weekly'
      }, {
        value: 'four-weekly',
        label: 'four-weekly'
      }, {
        value: 'monthly',
        label: 'monthly'
      }],
    };
  },
  created() {
    this.timeframe_student_loan_thresholds();
  },
  methods: {
    timeframe_student_loan_thresholds(){
      timeframe_student_loans(this).then((response)=> {
        this.student_loan_thresholds = response.data;
      });
    },
    create_student_loan_thresholds(){
      this.$refs['student_loan_threshold'].validate((valid) => {
        if (valid) {
          create_student_loan_thresholds(this, this.student_loan_threshold).then((response) => {
            this.$message({
              type: 'success',
              message: response.data.message
            });
            this.timeframe_student_loan_thresholds();
          });
        }
      });
    },
    delete_last_time_frame(){
      delete_timeframe_student_loans(this).then((response)=> {
        this.$message({
          type: 'success',
          message: response.data.message
        });
        this.timeframe_student_loan_thresholds();
      });
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style scoped>
#student-loan-thresholds /deep/ .el-dialog {
  width: 550px !important;
}
#student-loan-thresholds /deep/ .el-input{
  width: inherit;
}
</style>